{
  "Accessibility menu": "Menuya Gihîştinê",
  "Close": "Bigire",
  "Content adjustments": "Guhertinên Naverokê",
  "Navigation adjustments": "Guhertinên Navîgasyonê",
  "Align Left": "Çepê Rast Bike",
  "Adjust Font Size": "Mezinahiya Fontê biguherîne",
  "Highlight Title": "Sernavê nîşan bide",
  "Highlight Links": "Girêdanên nîşan bide",
  "Readable Font": "Fonta Xwendinê",
  "Colour adjustments": "Guhertinên Rengê",
  "Dark Contrast": "Pêvajoya Tarî",
  "Light Contrast": "Pêvajoya Ronahî",
  "High Contrast": "Pêvajoya Bilind",
  "High Saturation": "Tevgeriya Bilind",
  "Low Saturation": "Tevgeriya Nizm",
  "Monochrome": "Rengê Yekane",
  "Tools": "Amûr",
  "Reading Guide": "Rehbera Xwendinê",
  "Big Cursor": "Kursorê Mezin",
  "Increase Font Size": "Mezinahiya Fontê Mezinkirin",
  "Decrease Font Size": "Mezinahiya Fontê Kêmkirin",
  "Letter Spacing": "Dûrahiya Tîpan",
  "Line Height": "Bilindahiya Rêzê",
  "Font Weight": "Giraniya Fontê",
  "Dyslexia Font": "Fonta Disleksiya",
  "Language": "Ziman",
  "Accessibility widget": "Menuya Gihîştinê Vekirî",
  "Accessibility Profiles": "Profîlên Gihîştinê",
  "Cognitive Disability": "Seqetiya Zanînî",
  "Seizure Safe": "Ji bo Epilepsî Ewle",
  "Accessibility statement": "Daxuyaniya Gihîştinê",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "Anîmasyonan Rawestîne",
  "Reset all settings": "Mîhengên vegerandinê",
  "Shortcut:": "Shortcut:"
}
